import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Checkbox, FormControlLabel, Grid, TextField } from "@material-ui/core";
import { partial } from "ramda";
import { validateField, validateObject } from "../../../util/validation";

export const constraints = {
  optInName: {
    presence: {
      allowEmpty: false,
      message: "^Opt-In Name can't be blank",
    },
  },
  optInTitle: {
    presence: {
      allowEmpty: false,
      message: "^Opt-In Title can't be blank",
    },
  },
  acceptTitle: {
    presence: {
      allowEmpty: false,
      message: "^Accept Title can't be blank",
    },
  },
  acceptDescription: {
    presence: {
      allowEmpty: false,
      message: "^Accept Description can't be blank",
    },
  },
  declineTitle: {
    presence: {
      allowEmpty: false,
      message: "^Decline Title can't be blank",
    },
  },
  declineDescription: {
    presence: {
      allowEmpty: false,
      message: "^Decline Description can't be blank",
    },
  },
};

export const validateOptIn = partial(validateObject, [constraints]);
export const validateOptInField = (field, value, errors = {}) =>
  validateField(constraints, field, value, errors);

const textFields = [
  {
    id: "opt-in-name",
    name: "Opt-In Name",
    prop: "optInName",
    required: true,
    multiline: false,
    gridSize: 12,
    inputProps: {
      maxLength: 64,
    },
  },
  {
    id: "opt-in-title",
    name: "Opt-In Title",
    prop: "optInTitle",
    required: true,
    multiline: false,
    gridSize: 12,
    inputProps: {
      maxLength: 2048,
    },
  },
  {
    id: "opt-in-description",
    name: "Opt-In Description",
    prop: "optInDescription",
    required: false,
    multiline: true,
    gridSize: 12,
  },
  {
    id: "accept-title",
    name: "Accept Title",
    prop: "acceptTitle",
    required: true,
    multiline: false,
    gridSize: 4,
    inputProps: {
      maxLength: 64,
    },
  },
  {
    id: "accept-description",
    name: "Accept Description",
    prop: "acceptDescription",
    required: true,
    multiline: false,
    gridSize: 8,
    inputProps: {
      maxLength: 2048,
    },
  },
  {
    id: "decline-title",
    name: "Decline Title",
    prop: "declineTitle",
    required: true,
    multiline: false,
    gridSize: 4,
    inputProps: {
      maxLength: 64,
    },
  },
  {
    id: "decline-description",
    name: "Decline Description",
    prop: "declineDescription",
    required: true,
    multiline: false,
    gridSize: 8,
    inputProps: {
      maxLength: 2048,
    },
  },
  {
    id: "terms-uri",
    name: "Terms URI",
    prop: "termsUri",
    required: false,
    multiline: false,
    gridSize: 12,
    inputProps: {
      maxLength: 2048,
    },
  },
  {
    id: "logo-uri",
    name: "Logo URI",
    prop: "logoUri",
    required: false,
    multiline: false,
    gridSize: 12,
    inputProps: {
      maxLength: 2048,
    },
  },
];

const useStyles = makeStyles(() => ({
  optInDescription: {
    "& textarea": {
      height: "150px !important",
      overflowY: "auto !important",
      lineHeight: "2rem",
    },

    "& p.Mui-error": {
      top: "175px !important",
    },
  },
}));

const OptInForm = ({
  errors,
  handleBlur,
  handleChange,
  handleCheckbox,
  optIn,
}) => {
  const classes = useStyles();
  return (
    <Grid container spacing={4}>
      {textFields.map(field => (
        <Grid item xs={field.gridSize} key={field.id}>
          <TextField
            fullWidth
            className={classes?.[field.prop] ?? null}
            inputProps={field.inputProps}
            required={field.required}
            multiline={field.multiline}
            id={field.id}
            label={field.name}
            value={optIn[field.prop]}
            onChange={handleChange(field.prop)}
            onBlur={handleBlur(field.prop, optIn[field.prop])}
            error={Boolean(errors[field.prop])}
            helperText={
              errors[field.prop]
                ? errors[field.prop]
                : field?.helperText ?? null
            }
          />
        </Grid>
      ))}
      <Grid item xs={6}>
        <FormControlLabel
          label="Regional"
          control={
            <Checkbox
              color="primary"
              checked={optIn.regional}
              onChange={handleCheckbox("regional")}
              inputProps={{ "aria-label": "Select" }}
            />
          }
        />
      </Grid>
    </Grid>
  );
};

export default OptInForm;
